import React from 'react';
import { Button, Tooltip } from 'antd';
import { TimeKeeperDevice } from '@/DTOS/TimeKeeperDevice/Response/TimeKeeperDevice';
import { EditOutlined} from '@ant-design/icons';

export const TimeKeeperDeviceColumn = (
  handleEdit: (record: TimeKeeperDevice) => void
) => [
 
  {
    title: 'Device Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'SystemType Id',
    dataIndex: 'timeKeeperSystemTypeId',
    key: 'timeKeeperSystemTypeId',
    hidden: true,
  },
  {
    title: 'Serviciu',
    dataIndex: ['timeKeeperSystemType', 'name'],
    key: 'name',
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Canal',
    dataIndex: 'channel',
    key: 'channel',
  },
  {
    title: 'Tip',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: TimeKeeperDevice) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed:'right',
  },
];
